/**
 * Shell hook — returns testing-mode state or null (null = hide flask).
 *
 * Visibility gate: user.platformInternal === true AND meta.features.testingMode === true.
 * Mirrors BrandTalk's pattern exactly.
 */

import { useSelector } from 'react-redux';
import type { TestingModeState } from '@levelup/ui-shell';
import type { RootState } from '../store';

export function useTestingModeState(): TestingModeState | null {
  const user = useSelector((s: RootState) => s.boot.context?.user ?? null);
  const meta = useSelector((s: RootState) => s.boot.context?.meta ?? null);

  const isPlatformInternal = user?.platformInternal === true;
  const testingModeEnabled = meta?.features?.testingMode === true;
  if (!isPlatformInternal || !testingModeEnabled) return null;

  return {
    isActive: meta?.testingMode?.active === true,
    override: meta?.testingMode?.override,
  };
}
